export default __webpack_public_path__ + "static/media/amelie-picher-plante.13076363.jpg";